/* global CryptoJS */

var customerID = window.hulkappsWishlist.customerID;
var shopDomain = window.hulkappsWishlist.domain;
const encryptToken = generateEncryptToken(shopDomain, customerID);

function generateEncryptToken(domainName, customerId) {
  const rawString = `${domainName}${customerId}`;
  const hash = CryptoJS.SHA256(rawString).toString();
  console.log("Encrypt Token: ", btoa(hash));
  return btoa(hash);
}
function setCookie(name, value, days) {
  var expires = "";
  if (days) {
    var date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = "; expires=" + date.toUTCString();
  }
  document.cookie = name + "=" + (value || "") + expires + "; path=/";
}

function getQueryParameter(name) {
  var urlParams = new URLSearchParams(window.location.search);
  return urlParams.get(name);
}

function handleShareParameter() {
  var pathname = window.location.pathname;
  var listID = getQueryParameter("listID");

  if (pathname === "/apps/advanced-wishlist/share" && listID) {
    setCookie("Wishlist_listID", listID, 30);
  }
}

function getCookie(name) {
  var nameEQ = name + "=";
  var ca = document.cookie.split(";");
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == " ") c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
}

function getTextExcludingSpans(element) {
  let text = "";
  element.childNodes.forEach(node => {
    if (node.nodeType === Node.TEXT_NODE) {
      text += node.textContent; // Get text from text nodes
    } else if (node.nodeType === Node.ELEMENT_NODE && node.tagName !== "SPAN") {
      text += getTextExcludingSpans(node); // Recursively process child elements
    }
  });
  return text.trim();
}

function updateCredzPackLinks(wishlistListID) {
  const links = document.querySelectorAll(".sharedCredzPack-link");

  links.forEach(link => {
    link.href = "/apps/advanced-wishlist/share?listID=" + wishlistListID;
  });
}

handleShareParameter();

var wishlistListID = getCookie("Wishlist_listID");
if (wishlistListID) {
  window.wishlistListID = wishlistListID;
  document.body.classList.add("hasSharedWishlist");
  updateCredzPackLinks(window.wishlistListID);
} else {
  document.body.classList.remove("hasSharedWishlist");
}

function checkAndRedirect() {
  const body = document.body;

  const hasRestrictedPageClass = body.classList.contains("restricted-page");

  const hasCustomerLoggedInClass = body.classList.contains("customer-logged-in");
  const hasSharedWishlistClass = body.classList.contains("hasSharedWishlist");

  if (hasRestrictedPageClass && !hasCustomerLoggedInClass && !hasSharedWishlistClass) {
    window.location.href = "/";
  }
}

checkAndRedirect();

function addProductToWishlist(productId, variantId, wishlistIds) {
  return new Promise((resolve, reject) => {
    var addProductURL = "https://advanced-wishlist.hulkapps.com/api/public/v1/wishlist/add_product";
    var addProductData = {
      customer_id: customerID,
      shop: shopDomain,
      product_id: productId,
      variant_id: variantId,
      wishlist_ids: wishlistIds,
      // type: "web",
    };

    // Send the request to add the product to the new wishlist
    fetch(addProductURL, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization:
          "Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9.eyJhdWQiOiIxIiwianRpIjoiNjM1N2RmYjU3NGM3NjU0N2M3M2Q2ZWI4ZDk1ODg1N2FjOTg5MDgxYzE0ZjAyN2M4NWZjN2I1NzcwNDE3YmRlOTA1MzFmMjhhY2M1Y2M1OTkiLCJpYXQiOjE3MzI0NzM4NDgsIm5iZiI6MTczMjQ3Mzg0OCwiZXhwIjozNjI1OTI5ODQ4LCJzdWIiOiI4NzYxIiwic2NvcGVzIjpbXX0.C5ILB1v-0f4FnI3Zxrk5oLzhs2PQNQg4KyVFwlKIuUmsEOBhrVnsH93UV7ZrFHzMQens279QrjhDTWsOK0uDKQJFagkfojc5UczXfoHNuAab4qT30F-Y-8-LphYqNJrF8UnhL5sZAbyeWR-zQDDWCcXGxg57mF3psHy6FnB9EBKlBOmOpt-eYmS29aVPFNX05d0K3zNXRuntu8g6dy3loTLgcerCjys1JXL0M5vikc1kHv8MJiG16Ho1rxfsjQHoN4VY2XeuhLPUbCmjne5mrj7HQLqLNmd8Z2DEk115DZyQKmRPbzYUHpFtLcgXn9w-nPtUiwyGdZFWYLfvo0tIktkf4jCQVHyMBTWLg7ICzCeCHM8pHHrD0rJep04diiBgKzsTYFiV7lNeloIIk51dAGaylUW929jmVG_OpLHrh93JeD3xQSOW5Zhri5Lu4NH7spXVwaNRIAYSw4o2Zvyl2U9IXMgniCSIuTELObUCV2h1FMwbiF17QhnrJkvxJbmmIs9pVw-iS6CsRvKg1JR50SR5eug3L_PFLuK53DDx69N3XTJu5rVO3_qp796DfUOBIsErOqENw65E8kSAoRm6SeDLqO3KEv3F293ZRnyAy-7z4xZFgJAHiy7H4VZf9sP7WC_-sywJ6OZ2AeQ2wevU33JNR1GABg8K7sm6u8ujt4A",
        "Encrypt-Token": encryptToken,
      },
      body: JSON.stringify(addProductData),
    })
      .then(response => {
        if (!response.ok) {
          console.error(`Failed to add product ${productId} to wishlists: ${response.statusText}`);
        } else {
          console.log(`Product ${productId} successfully added to wishlists`);
          resolve();
        }
      })
      .catch(error => {
        console.error("Error adding product to wishlist:", error);
        reject();
      });
  });
}

function duplicateWishlist(oldWishlistID, oldWishlistTitle) {
  var getProductsURL =
    "https://advanced-wishlist.hulkapps.com/api/public/v1/wishlist/products?customer_id=" +
    customerID +
    "&shop=" +
    shopDomain +
    "&wishlist_id=" +
    oldWishlistID;

  fetch(getProductsURL, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization:
        "Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9.eyJhdWQiOiIxIiwianRpIjoiNjM1N2RmYjU3NGM3NjU0N2M3M2Q2ZWI4ZDk1ODg1N2FjOTg5MDgxYzE0ZjAyN2M4NWZjN2I1NzcwNDE3YmRlOTA1MzFmMjhhY2M1Y2M1OTkiLCJpYXQiOjE3MzI0NzM4NDgsIm5iZiI6MTczMjQ3Mzg0OCwiZXhwIjozNjI1OTI5ODQ4LCJzdWIiOiI4NzYxIiwic2NvcGVzIjpbXX0.C5ILB1v-0f4FnI3Zxrk5oLzhs2PQNQg4KyVFwlKIuUmsEOBhrVnsH93UV7ZrFHzMQens279QrjhDTWsOK0uDKQJFagkfojc5UczXfoHNuAab4qT30F-Y-8-LphYqNJrF8UnhL5sZAbyeWR-zQDDWCcXGxg57mF3psHy6FnB9EBKlBOmOpt-eYmS29aVPFNX05d0K3zNXRuntu8g6dy3loTLgcerCjys1JXL0M5vikc1kHv8MJiG16Ho1rxfsjQHoN4VY2XeuhLPUbCmjne5mrj7HQLqLNmd8Z2DEk115DZyQKmRPbzYUHpFtLcgXn9w-nPtUiwyGdZFWYLfvo0tIktkf4jCQVHyMBTWLg7ICzCeCHM8pHHrD0rJep04diiBgKzsTYFiV7lNeloIIk51dAGaylUW929jmVG_OpLHrh93JeD3xQSOW5Zhri5Lu4NH7spXVwaNRIAYSw4o2Zvyl2U9IXMgniCSIuTELObUCV2h1FMwbiF17QhnrJkvxJbmmIs9pVw-iS6CsRvKg1JR50SR5eug3L_PFLuK53DDx69N3XTJu5rVO3_qp796DfUOBIsErOqENw65E8kSAoRm6SeDLqO3KEv3F293ZRnyAy-7z4xZFgJAHiy7H4VZf9sP7WC_-sywJ6OZ2AeQ2wevU33JNR1GABg8K7sm6u8ujt4A",
      "Encrypt-Token": encryptToken,
    },
  })
    .then(response => {
      // Check if response is ok, throw an error otherwise
      if (!response.ok) {
        throw new Error("Failed to fetch products from the wishlist");
      }
      return response.json();
    })
    .then(data => {
      var products = data.data; // Access products data from response

      createNewWishlist(products, oldWishlistID, oldWishlistTitle);
    })
    .catch(error => {
      console.error("Error duplicating wishlist:", error);
    });
}

function fetchProductsWishlists(products, newWishlistID) {
  const url = new URL("https://advanced-wishlist.hulkapps.com/api/public/v1/wishlist/product_status");

  let headers = {
    Accept: "application/json",
    "Content-Type": "application/json",
    Authorization:
      "Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9.eyJhdWQiOiIxIiwianRpIjoiNjM1N2RmYjU3NGM3NjU0N2M3M2Q2ZWI4ZDk1ODg1N2FjOTg5MDgxYzE0ZjAyN2M4NWZjN2I1NzcwNDE3YmRlOTA1MzFmMjhhY2M1Y2M1OTkiLCJpYXQiOjE3MzI0NzM4NDgsIm5iZiI6MTczMjQ3Mzg0OCwiZXhwIjozNjI1OTI5ODQ4LCJzdWIiOiI4NzYxIiwic2NvcGVzIjpbXX0.C5ILB1v-0f4FnI3Zxrk5oLzhs2PQNQg4KyVFwlKIuUmsEOBhrVnsH93UV7ZrFHzMQens279QrjhDTWsOK0uDKQJFagkfojc5UczXfoHNuAab4qT30F-Y-8-LphYqNJrF8UnhL5sZAbyeWR-zQDDWCcXGxg57mF3psHy6FnB9EBKlBOmOpt-eYmS29aVPFNX05d0K3zNXRuntu8g6dy3loTLgcerCjys1JXL0M5vikc1kHv8MJiG16Ho1rxfsjQHoN4VY2XeuhLPUbCmjne5mrj7HQLqLNmd8Z2DEk115DZyQKmRPbzYUHpFtLcgXn9w-nPtUiwyGdZFWYLfvo0tIktkf4jCQVHyMBTWLg7ICzCeCHM8pHHrD0rJep04diiBgKzsTYFiV7lNeloIIk51dAGaylUW929jmVG_OpLHrh93JeD3xQSOW5Zhri5Lu4NH7spXVwaNRIAYSw4o2Zvyl2U9IXMgniCSIuTELObUCV2h1FMwbiF17QhnrJkvxJbmmIs9pVw-iS6CsRvKg1JR50SR5eug3L_PFLuK53DDx69N3XTJu5rVO3_qp796DfUOBIsErOqENw65E8kSAoRm6SeDLqO3KEv3F293ZRnyAy-7z4xZFgJAHiy7H4VZf9sP7WC_-sywJ6OZ2AeQ2wevU33JNR1GABg8K7sm6u8ujt4A",
    "Encrypt-Token": encryptToken,
  };

  let body = {
    customer_id: customerID,
    ids: products,
  };

  fetch(url, {
    method: "POST",
    headers,
    body: JSON.stringify(body),
  })
    .then(response => {
      if (!response.ok) {
        throw new Error("Failed to fetch products from the wishlist");
      }
      return response.json();
    })
    .then(data => {
      // Create an array of promises for adding products to the wishlist
      const promises = data.map(product => {
        let wishlistIds = product.wishlist_ids;
        wishlistIds = wishlistIds.concat(newWishlistID);
        return addProductToWishlist(product.product_id, product.variant_id, wishlistIds);
      });

      // Wait for all addProductToWishlist promises to settle
      return Promise.allSettled(promises);
    })
    .then(results => {
      // Log results for debugging
      results.forEach((result, index) => {
        if (result.status === "fulfilled") {
          console.log(`Product ${index} added successfully.`);
        } else {
          console.error(`Error adding product ${index}:`, result.reason);
        }
      });

      // Reload the page after all promises settle
      console.log("All products processed. Reloading the page.");
      console.log("TEXT");
      window.location.reload();
    })
    .catch(error => {
      console.error("Error duplicating wishlist:", error);
    });
}

function createNewWishlist(products, oldWishlistID, oldWishlistTitle) {
  if (!products || products.length === 0) {
    throw new Error("No products found in the original wishlist");
  }
  console.log(products);

  // Step 2: Create a new wishlist
  var newWishlistName = oldWishlistTitle + " - (Copy)"; // Adjust the name if needed
  var newWishlistData = {
    customer_id: customerID,
    shop: shopDomain,
    name: newWishlistName,
  };

  return fetch(window.hulkappsWishlist.baseURL + "/wishlist/create", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(newWishlistData),
  })
    .then(response => {
      // Check if response is ok, throw an error otherwise
      if (!response.ok) {
        throw new Error("Failed to create new wishlist");
      }
      return response.json();
    })
    .then(newWishlist => {
      var newWishlistID = newWishlist.data.id; // New wishlist ID

      console.log("New wishlist created successfully:", newWishlistID, "Old wishlist ID:", oldWishlistID);

      console.log(products);

      fetchProductsWishlists(products, newWishlistID);

      console.log("Wishlist duplicated successfully!");

      return true;
    });
}

// Layout modifications
function moveLayoutElements() {
  const ul = document.querySelector(".sidebar_list:not([data-hulkwishlistlisting])");
  const headerLi = document.querySelector("#wishlistCustomElements li.sidebar_header");

  if (ul) ul.insertBefore(headerLi, ul.firstChild);

  const listHeaderTitleContainer = document.createElement("div");
  listHeaderTitleContainer.classList.add("title-container");
  const projectListHeader = document.querySelector(".list-header");
  const projectListTitle = document.querySelector("[data-mywishlisttitle]");
  const shareProjectButton = document.querySelector("#wishlistCustomElements .share_wishlist");
  const deleteWishlistButton = document.querySelector("#wishlistCustomElements .delete_wishlist");
  const duplicateWishlistButton = document.querySelector("#wishlistCustomElements .duplicate_wishlist");
  const wishlistContainer = document.querySelector("[data-wishlistcontainer]");

  if (listHeaderTitleContainer && projectListTitle)
    listHeaderTitleContainer.insertBefore(projectListTitle, listHeaderTitleContainer.firstChild);
  if (projectListHeader && listHeaderTitleContainer)
    projectListHeader.insertBefore(listHeaderTitleContainer, projectListHeader.firstChild);
  if (projectListHeader && shareProjectButton)
    projectListHeader.insertBefore(shareProjectButton, projectListHeader.lastChild);

  if (window.location.href.includes("apps/advanced-wishlist/share")) {
    const wishlistWrapper = document.querySelector(".hulk__wishlist-wrap");
    const sharedWishlistHeader = document.querySelector("#wishlistCustomElements .shared-wishlist-header");
    wishlistWrapper.insertBefore(sharedWishlistHeader, wishlistWrapper.firstChild);
  } else {
    if (wishlistContainer && deleteWishlistButton)
      wishlistContainer.insertBefore(deleteWishlistButton, wishlistContainer.lastChild);
    if (wishlistContainer && duplicateWishlistButton)
      wishlistContainer.insertBefore(duplicateWishlistButton, wishlistContainer.lastChild);
  }
}

function addEventsListeners() {
  const shareProjectButton = document.querySelector(".list-header .share_wishlist");
  if (shareProjectButton) {
    shareProjectButton.addEventListener("click", function (e) {
      // const listShareButton = document.querySelector(".sidebar_item.active [data-hulksharewishlist]");
      const listShareButton = document.querySelector(".sidebar_list li.sidebar_item.active [data-hulksharewishlist]");
      const listId = document.querySelector(".sidebar_item.active").getAttribute("data-uniqid");
      e.preventDefault();
      listShareButton.click();

      let url = "momentfactory.com/apps/advanced-wishlist/share?listID=" + listId;

      navigator.clipboard.writeText(url).then(
        function () {
          console.log("Copied!");
        },
        function () {
          console.log("Copy error");
        },
      );
    });
  }

  const deleteWishlistButton = document.querySelector("[data-wishlistcontainer] .delete_wishlist");
  if (deleteWishlistButton) {
    deleteWishlistButton.addEventListener("click", function (e) {
      const listDeleteButton = document.querySelector(".sidebar_item.active [data-confirmdeletewishlist]");
      e.preventDefault();
      listDeleteButton.click();
    });
  }

  const duplicateWishlistButton = document.querySelector("[data-wishlistcontainer] .duplicate_wishlist");
  if (duplicateWishlistButton) {
    duplicateWishlistButton.addEventListener("click", function (e) {
      e.preventDefault();
      var activeSidebarItem = document.querySelector(".sidebar_container .sidebar_list .sidebar_item.active");

      if (activeSidebarItem) {
        var dataId = activeSidebarItem.getAttribute("data-id");
        var dataTitle = getTextExcludingSpans(activeSidebarItem.querySelector("[data-hulkwishlisttitle]"));

        console.log("Data ID of the active sidebar item:", dataId, dataTitle);

        duplicateWishlist(dataId, dataTitle);
      } else {
        console.error("No active sidebar item found.");
      }
    });
  }
}

function addDelayedEventsListeners() {
  let wishlistSidebarButtons = document.querySelectorAll("[data-hulkwishlisttitle]");
  console.log(wishlistSidebarButtons);
  if (wishlistSidebarButtons) {
    wishlistSidebarButtons.forEach(element => {
      console.log(element);
      element.addEventListener("click", () => {
        console.log(element);
        const newText = getTextExcludingSpans(element);
        const myWishlistElement = document.querySelector("[data-mywishlisttitle]");
        if (myWishlistElement) {
          myWishlistElement.textContent = newText;
        } else {
          console.warn("Element with data-mywishlisttitle attribute not found.");
        }
      });
    });
  }
}

function moveLayoutElementsAfter() {}

function updateWishlistTitle() {
  const sidebarItems = document.querySelectorAll(".sidebar_item");
  const projectTitleElement = document.querySelector("[data-mywishlisttitle]");

  const sidebarItemCallback = function (mutationsList) {
    for (let mutation of mutationsList) {
      if (mutation.type === "attributes" && mutation.attributeName === "class") {
        const targetElement = mutation.target;
        if (targetElement.classList.contains("active")) {
          projectTitleElement.textContent = targetElement
            .querySelector("[data-hulkwishlisttitle]")
            .childNodes[0].textContent.trim();
        }
        if (sidebarItems[0] === targetElement) {
          document.querySelector(".edit-title-button").style.display = "none";
          document.querySelector("[data-wishlistcontainer] .delete_wishlist").style.display = "none";
        } else {
          document.querySelector(".edit-title-button").style.display = "block";
          document.querySelector("[data-wishlistcontainer] .delete_wishlist").style.display = "inline-block";
        }
      }
    }
  };

  const wishlistObserver = new MutationObserver(sidebarItemCallback);
  const wishlistListItemConfig = {attributes: true, attributeFilter: ["class"]};

  sidebarItems.forEach(item => {
    wishlistObserver.observe(item, wishlistListItemConfig);
  });
}

function addEditFunctionality() {
  // Select the element with data-mywishlisttitle attribute
  const wishlistTitleElement = document.querySelector("[data-mywishlisttitle]");
  const titleContainer = document.querySelector(".list-header .title-container");

  // Create the "Edit" button
  const editButton = document.createElement("button");
  editButton.classList.add("edit-title-button");
  editButton.textContent = "Edit";

  // Insert the "Edit" button after the wishlist title
  if (wishlistTitleElement) wishlistTitleElement.after(editButton);

  let inputField; // Declare input field variable
  let cancelButton; // Declare cancel button variable
  let originalText; // Variable to store the original text

  // Add click event listener to the "Edit" button
  if (editButton)
    editButton.addEventListener("click", function () {
      if (editButton.textContent === "Edit") {
        // Get the current text content
        originalText = wishlistTitleElement.childNodes[0].textContent.trim();

        // Create an input field
        inputField = document.createElement("input");
        inputField.type = "text";
        inputField.placeholder = originalText; // Set the placeholder as the current text
        inputField.value = originalText; // Pre-fill with the current text

        // Replace the text element with the input field
        wishlistTitleElement.innerHTML = ""; // Clear the current content
        wishlistTitleElement.appendChild(inputField); // Insert the input field

        // Focus on the input field for user convenience
        inputField.focus();

        // Change the button text to "Update"
        editButton.textContent = "Update";
        titleContainer.classList.add("update-title-button__wrapper");

        // Create a "Cancel" button
        cancelButton = document.createElement("button");
        cancelButton.textContent = "Cancel";
        cancelButton.style.marginLeft = "10px";
        editButton.after(cancelButton); // Insert Cancel button after Update button

        // Cancel button logic to revert changes
        cancelButton.addEventListener("click", function () {
          cancelEdit();
        });

        // Listen for key presses on input field
        inputField.addEventListener("keydown", function (event) {
          if (event.key === "Enter") {
            updateWishlist(); // Trigger update when Enter is pressed
            setTimeout(() => {
              window.location.reload();
            }, "500");
          } else if (event.key === "Escape") {
            cancelEdit(); // Trigger cancel when Escape is pressed
          }
        });
      } else if (editButton.textContent === "Update") {
        updateWishlist();
        setTimeout(() => {
          window.location.reload();
        }, "500");
      }
    });

  // Function to handle the update process
  function updateWishlist() {
    // Update the value of the .sidebar_item.active [data-updatewishlistinput] element
    const activeSidebarItemInput = document.querySelector(".sidebar_item.active [data-updatewishlistinput]");
    const activeSidebarItemSubmit = document.querySelector(".sidebar_item.active [data-updateexistingwishlist]");

    if (activeSidebarItemInput && inputField) {
      activeSidebarItemInput.value = inputField.value; // Set the input's value to the updated value
      activeSidebarItemSubmit.click(); // Trigger form submission or update action
    }

    // Replace input with the updated text
    wishlistTitleElement.innerHTML = inputField.value || inputField.placeholder;

    // Change the button text back to "Edit"
    editButton.textContent = "Edit";
    titleContainer.classList.remove("update-title-button__wrapper");

    // Remove the Cancel button
    cancelButton.remove();
  }

  // Function to handle the cancel process
  function cancelEdit() {
    // Revert the title text to the original value
    wishlistTitleElement.innerHTML = originalText;

    // Change the button text back to "Edit"
    editButton.textContent = "Edit";
    titleContainer.classList.remove("update-title-button__wrapper");

    // Remove the Cancel button
    cancelButton.remove();
  }
}

function updateEvents() {
  const quickViewElements = document.querySelectorAll("[data-hulkquickviewele]");
  const wishlistLinks = document.querySelectorAll("a.wishlist-product__image");

  quickViewElements.forEach(quickViewElement => {
    quickViewElement.removeAttribute("data-hulkquickviewele");
  });

  wishlistLinks.forEach(link => {
    link.addEventListener("click", event => {
      event.preventDefault(); // Prevents the default click behavior
    });
  });
}

function watchWishlistTitle() {
  const targetElement = document.querySelector("[data-wishlisttitle]");
  if (!targetElement) {
    console.error("Element with attribute data-wishlisttitle not found.");
    return;
  }

  let changes = [];
  let timer;

  // MutationObserver to track changes in text content
  const observer = new MutationObserver(mutations => {
    mutations.forEach(mutation => {
      if (mutation.type === "characterData" || mutation.type === "childList") {
        const currentText = targetElement.textContent.trim();
        if (!changes.includes(currentText)) {
          changes.push(currentText);
        }

        // Clear and reset the timer
        clearTimeout(timer);
        timer = setTimeout(() => {
          const newText = changes.find(text => text !== "Shared lists");
          if (newText) {
            targetElement.textContent = newText;
            targetElement.style.opacity = 1;
          }
          changes = []; // Clear the array after processing
        }, 1000);
      }
    });
  });

  // Start observing the target element for text content changes
  observer.observe(targetElement, {
    characterData: true,
    childList: true,
    subtree: true,
  });

  console.log("Watching for changes in the wishlist title...");
}

function updateEmptyContentMessage() {
  const emptyContentElement = document.querySelector(".empty_content");

  if (!emptyContentElement) {
    console.error('Element with class "empty_content" not found.');
    return;
  }

  const h3Element = emptyContentElement.querySelector("h3");

  if (!h3Element) {
    console.error('No <h3> element found inside the "empty_content" element.');
    return;
  }

  h3Element.textContent = "This Shared list is no longer active.";
  console.log("Updated the text of the <h3> element successfully.");
}

(function () {
  if (window.location.href.includes("apps/advanced-wishlist")) {
    moveLayoutElements();
    addEventsListeners();
    addEditFunctionality();

    setTimeout(() => {
      moveLayoutElementsAfter();
      updateWishlistTitle();
      addDelayedEventsListeners();
    }, "1000");

    if (window.location.href.includes("apps/advanced-wishlist/share")) {
      watchWishlistTitle();
      updateEmptyContentMessage();
    } else {
      setTimeout(() => {
        updateEvents();
      }, "2000");
    }
  }
})();
